/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_soon = /** @type {(inputs: {}) => string} */ () => {
	return `Demnächst`
};

const en_soon = /** @type {(inputs: {}) => string} */ () => {
	return `Coming soon`
};

const es_soon = /** @type {(inputs: {}) => string} */ () => {
	return `Próximamente`
};

const fr_soon = /** @type {(inputs: {}) => string} */ () => {
	return `Bientôt`
};

const it_soon = /** @type {(inputs: {}) => string} */ () => {
	return `Prossimamente`
};

const nl_soon = /** @type {(inputs: {}) => string} */ () => {
	return `Binnenkort beschikbaar`
};

const pt_soon = /** @type {(inputs: {}) => string} */ () => {
	return `Em breve`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const soon = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.soon(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("soon", locale)
	if (locale === "de") return de_soon(inputs)
	if (locale === "en") return en_soon(inputs)
	if (locale === "es") return es_soon(inputs)
	if (locale === "fr") return fr_soon(inputs)
	if (locale === "it") return it_soon(inputs)
	if (locale === "nl") return nl_soon(inputs)
	return pt_soon(inputs)
};